<div class="gridview-row">
  <div [title]="tooltip || header">{{header}}</div>
  <div [title]="getFileInfoText()">
    @if (isLoading) {
      <span>Loading data...</span>
    }
    @if (!isLoading && !hasDownloadAccess) {
      <span>No access</span>
    }
    @if (!isLoading && hasDownloadAccess && !backupFile) {
      <span>Not available</span>
    }
    @if (!isLoading && hasDownloadAccess && backupFile) {
      <span>{{backupFile?.FileName}}</span>
    }
  </div>
  @if (hasDownloadAccess && backupFile) {
    <div class="toolbar">
      @if (permissionShowStylesheet && stylesheetIdentifier && stylesheetIdentifier !== '00000000-0000-0000-0000-000000000000') {
        <button class="btn btn-link" (click)="showStylesheet()">Print <ep-svg-icon icon="printer"></ep-svg-icon></button>
      }
      @if (permissionDownloadCdmAttachment && showAttachmentButton) {
        <button class="btn btn-link" (click)="downloadCdmAttachment()">Attachment <ep-svg-icon icon="paper-clip"></ep-svg-icon></button>
      }
      @if (backupFile) {
        <span title="Created date: {{dateTimeService.getDevExpressDateTimeWithMsFunction($safeNavigationMigration(backupFile?.CreatedDate))}}">{{dateTimeService.getFormattedTime($safeNavigationMigration(backupFile?.CreatedDate))}} <ep-svg-icon icon="clock"></ep-svg-icon></span>
      }
      @if (permissionShowFile && backupFile) {
        <ep-tracking-document-shower [documentId]="documentId" [interchangeInId]="interchangeInId" [fileIdentifier]="fileIdentifier" [fileType]="fileType"></ep-tracking-document-shower>
      }
      @if (permissionDownloadFile && backupFile) {
        <button class="btn btn-link" (click)="downloadFile()">Save @if (!showDownloadIndicator) {
          <ep-svg-icon icon="inbox"></ep-svg-icon>
          }@if (showDownloadIndicator) {
          <img title="Downloading file..." src="../../images/ajax-loader.gif" />
        }</button>
      }
      @if (backupFile) {
        <span title="Full length in bytes: {{backupFile?.FileSize}}">Size: {{getReadableFileSize()}}</span>
      }
    </div>
  }
</div>
